const selector = "[data-nav-trigger]";

let els = null;

function NavTriggers() {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Loop through them
	[].forEach.call(els, function(item) {
		item.addEventListener("click", function(e) {
			console.log(e);
			
			const navId     = e.target.dataset.navTrigger;
			const openClass = "nav-" + navId + "-open";
	
			document.documentElement.classList.toggle(openClass);
		})
	});
}

export default NavTriggers;